<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultOptions: {
        cutoutPercentage: 70,
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: true
        }
      }
    }
  },
  computed: {
    chartOptions() {
      return this.options || this.defaultOptions;
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.chartOptions)
  }
};
</script>
